import { ACHIEVEMENTS } from "@dailywars/core/achievements";
import { getAllAchievementGrants, getPlayer, isRegisteredPlayerId } from "@dailywars/core/db";
import { createServerFn } from "@tanstack/react-start";

import { setRouteAction } from "#/lib/requestLogger.server";
import { getPlayerPreviewInputSchema } from "#/lib/serverInputSchemas";

export type PlayerPreview = {
  displayName: string;
  gamesCompleted: number;
  goldMedals: number;
  silverMedals: number;
  bronzeMedals: number;
  standardDailyStreak: number;
  premiumDailyStreak: number;
  earnedAchievementCount: number;
  totalAchievementCount: number;
};

export const getPlayerPreview = createServerFn({ method: "GET" })
  .validator(getPlayerPreviewInputSchema)
  .handler(async ({ data }): Promise<PlayerPreview | null> => {
    setRouteAction("player_preview");
    if (!isRegisteredPlayerId(data.playerId)) return null;
    const [player, grants] = await Promise.all([
      getPlayer(data.playerId),
      getAllAchievementGrants(data.playerId),
    ]);
    if (!player) return null;
    return {
      displayName: player.displayName,
      gamesCompleted: player.gamesCompleted ?? 0,
      goldMedals: player.goldMedals ?? 0,
      silverMedals: player.silverMedals ?? 0,
      bronzeMedals: player.bronzeMedals ?? 0,
      standardDailyStreak: player.standardDailyStreak ?? 0,
      premiumDailyStreak: player.premiumDailyStreak ?? 0,
      earnedAchievementCount: grants.length,
      totalAchievementCount: ACHIEVEMENTS.length,
    };
  });
